export class PartialSubmission {
  completeApplicationPartRequestId: number;
  jobSiteRelativeUrl: string;
  emailAddress: string;
  applicantElement: string;
  jobId: number;
}
